import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { navItems } from '../data/navigation';
export function Footer() {
  return <footer className="bg-ink text-paper" data-id="element-10" data-mp="3ghc0bvkn0rl2">
      <div className="mx-auto max-w-site px-6 py-16 lg:px-10" data-id="element-11" data-mp="32onk11rpbm8f">
        <div className="grid gap-12 md:grid-cols-12" data-id="element-12" data-mp="32m1ef7odfgsu">
          <div className="md:col-span-5" data-id="element-13" data-mp="36q953aee36tp">
            <Logo inverted data-id="element-14" data-mp="36n3grxdl48z1" />
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-paper/70" data-id="element-15" data-mp="3ueih5klswg7n">
              Cabinet de conseil indépendant au service des politiques publiques de l’habitat et de la
              transformation des quartiers.
            </p>
          </div>

          <nav aria-label="Plan du site" className="md:col-span-3" data-id="element-16" data-mp="3lgoocjn8w4p8">
            <h2 className="text-sm text-paper/50" data-id="element-17" data-mp="3qbvm7atu2f68">Plan du site</h2>
            <ul className="mt-4 space-y-3" data-id="element-18" data-mp="29yxe3g083qne">
              {navItems.map(item => <li key={item.path} data-id="element-19" data-mp="2ey05vyr700df">
                  <Link to={item.path} className="text-[15px] text-paper/85 transition-colors duration-150 hover:text-paper" data-id="element-20" data-mp="2ez1nkm2prl44">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <address className="not-italic md:col-span-4" data-id="element-21" data-mp="3v919hopjxr6m">
            <h2 className="text-sm text-paper/50" data-id="element-22" data-mp="3q83q58st2r3j">Siège</h2>
            <p className="mt-4 text-[15px] leading-relaxed text-paper/85" data-id="element-23" data-mp="3qazr75zy9vw7">
              24, rue des Archives
              <br data-id="element-24" data-mp="33xe1y3atysi" />
              75004 Paris
            </p>
            <p className="mt-4 text-[15px] leading-relaxed text-paper/85" data-id="element-25" data-mp="33e536vmmkqm">
              <a href="tel:+33142000000" className="hover:text-paper" data-id="element-26" data-mp="hrs6dddea152">
                01 42 00 00 00
              </a>
              <br data-id="element-27" data-mp="cu8ugk4660ga" />
              <a href="mailto:contact@ancrages-conseil.fr" className="hover:text-paper" data-id="element-28" data-mp="cvto87intfd3">
                contact@ancrages-conseil.fr
              </a>
            </p>
          </address>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-paper/15 pt-8 text-sm text-paper/50 md:flex-row md:items-center md:justify-between" data-id="element-29" data-mp="mptq80ina4hl">
          <p data-id="element-30" data-mp="ytek6ham6csq">© 2026 Ancrages Conseil. Tous droits réservés.</p>
          <ul className="flex flex-wrap gap-6" data-id="element-31" data-mp="13tammc3nxw66">
            <li data-id="element-32" data-mp="13sipuxybxseb">
              <a href="#" className="hover:text-paper" data-id="element-33" data-mp="13rpoydm1xx43">Mentions légales</a>
            </li>
            <li data-id="element-34" data-mp="18lk7vetu2824">
              <a href="#" className="hover:text-paper" data-id="element-35" data-mp="18m3rczz4t4i9">Politique de confidentialité</a>
            </li>
            <li data-id="element-36" data-mp="1cnoy03l2omk0">
              <a href="#" className="hover:text-paper" data-id="element-37" data-mp="1hkp6el5ea1ea">Accessibilité</a>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}